import { ComponentProps, FC } from 'react';
import { styled } from '@mui/material';

type TDirection = 'top' | 'bottom' | 'right' | 'left';

const DIRECTION_DEGREES: Record<TDirection, number> = {
	bottom: 0,
	left: 90,
	top: 180,
	right: 270,
};

interface IShortArrowIconProps extends ComponentProps<'svg'> {
	direction?: TDirection;
}

const ShortArrow: FC<IShortArrowIconProps> = ({
	direction = 'bottom',
	...props
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="24"
		height="24"
		fill="none"
		viewBox="0 0 24 24"
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			d="M11.89 13.42L6.94 8.47 5.53 9.9l4.94 4.95.71.7a1 1 0 001.42 0l.7-.7 4.95-4.95-1.41-1.42-4.95 4.95z"
			clipRule="evenodd"
		></path>
	</svg>
);

ShortArrow.displayName = 'ShortArrowIcon';

export const ShortArrowIcon = styled(ShortArrow, {
	shouldForwardProp: (prop) => prop !== 'direction',
})<IShortArrowIconProps>(({ direction = 'bottom' }) => ({
	transform: `rotate(${DIRECTION_DEGREES[direction]}deg)`,
	transition: 'transform ease .2s',
}));
